"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("./index"));
var _lodashReplacement = _interopRequireDefault(require("./lodashReplacement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* global postal, _ */

const {
  after,
  isEqual,
  extend,
  debounce: debounceLodash,
  throttle: throttleLodash
} = _lodashReplacement.default;
var SubscriptionDefinition = function SubscriptionDefinition(channel, topic, callback) {
  if (arguments.length !== 3) {
    throw new Error("You must provide a channel, topic and callback when creating a SubscriptionDefinition instance.");
  }
  if (topic.length === 0) {
    throw new Error("Topics cannot be empty");
  }
  this.channel = channel;
  this.topic = topic;
  this.callback = callback;
  this.pipeline = [];
  this.cacheKeys = [];
  this._context = undefined;
};
var ConsecutiveDistinctPredicate = function ConsecutiveDistinctPredicate() {
  var previous;
  return function (data) {
    var eq = false;
    if (typeof data === "string") {
      eq = data === previous;
      previous = data;
    } else {
      eq = isEqual(data, previous);
      previous = extend({}, data);
    }
    return !eq;
  };
};
var DistinctPredicate = function DistinctPredicateFactory() {
  var previous = [];
  return function DistinctPredicate(data) {
    var isDistinct = !previous.some(function (p) {
      return isEqual(data, p);
    });
    if (isDistinct) {
      previous.push(data);
    }
    return isDistinct;
  };
};
SubscriptionDefinition.prototype = {
  catch: function _catch(errorHandler) {
    var original = this.callback;
    var safeCallback = function safeCallback() {
      try {
        original.apply(this, arguments);
      } catch (err) {
        errorHandler(err, arguments[0]);
      }
    };
    this.callback = safeCallback;
    return this;
  },
  defer: function defer() {
    return this.delay(0);
  },
  disposeAfter: function disposeAfter(maxCalls) {
    if (typeof maxCalls !== "number" || maxCalls <= 0) {
      throw new Error("The value provided to disposeAfter (maxCalls) must be a number greater than zero.");
    }
    var dispose = after(maxCalls, this.unsubscribe.bind(this));
    this.pipeline.push(function (data, env, next) {
      next(data, env);
      dispose();
    });
    return this;
  },
  distinct: function distinct() {
    return this.constraint(new DistinctPredicate());
  },
  distinctUntilChanged: function distinctUntilChanged() {
    return this.constraint(new ConsecutiveDistinctPredicate());
  },
  invokeSubscriber: function invokeSubscriber(data, env) {
    if (!this.inactive) {
      var self = this;
      var pipeline = self.pipeline;
      var len = pipeline.length;
      var context = self._context;
      var idx = -1;
      var invoked = false;
      if (!len) {
        self.callback.call(context, data, env);
        invoked = true;
      } else {
        pipeline = pipeline.concat([self.callback]);
        var step = function step(d, e) {
          idx += 1;
          if (idx < len) {
            pipeline[idx].call(context, d, e, step);
          } else {
            self.callback.call(context, d, e);
            invoked = true;
          }
        };
        step(data, env, 0);
      }
      return invoked;
    }
  },
  logError: function logError() {
    /* istanbul ignore else */
    if (console) {
      var report;
      if (console.warn) {
        report = console.warn;
      } else {
        report = console.log;
      }
      this.catch(report);
    }
    return this;
  },
  once: function once() {
    return this.disposeAfter(1);
  },
  subscribe: function subscribe(callback) {
    this.callback = callback;
    return this;
  },
  unsubscribe: function unsubscribe() {
    /* istanbul ignore else */
    if (!this.inactive) {
      _index.default.unsubscribe(this);
    }
  },
  constraint: function constraint(predicate) {
    if (typeof predicate !== "function") {
      throw new Error("Predicate constraint must be a function");
    }
    this.pipeline.push(function (data, env, next) {
      if (predicate.call(this, data, env)) {
        next(data, env);
      }
    });
    return this;
  },
  constraints: function constraints(predicates) {
    var self = this;
    /* istanbul ignore else */
    predicates.forEach(function (predicate) {
      self.constraint(predicate);
    });
    return self;
  },
  context: function contextSetter(context) {
    this._context = context;
    return this;
  },
  debounce: function debounce(milliseconds, immediate) {
    if (typeof milliseconds !== "number") {
      throw new Error("Milliseconds must be a number");
    }
    var options = {};
    if (!!immediate === true) {
      //jshint ignore:line
      options.leading = true;
      options.trailing = false;
    }
    this.pipeline.push(debounceLodash(function (data, env, next) {
      next(data, env);
    }, milliseconds, options));
    return this;
  },
  delay: function delay(milliseconds) {
    if (typeof milliseconds !== "number") {
      throw new Error("Milliseconds must be a number");
    }
    var self = this;
    self.pipeline.push(function (data, env, next) {
      setTimeout(function () {
        next(data, env);
      }, milliseconds);
    });
    return this;
  },
  throttle: function throttle(milliseconds) {
    if (typeof milliseconds !== "number") {
      throw new Error("Milliseconds must be a number");
    }
    var fn = function fn(data, env, next) {
      next(data, env);
    };
    this.pipeline.push(throttleLodash(fn, milliseconds));
    return this;
  }
};
var _default = SubscriptionDefinition;
exports.default = _default;